<template>
  <div class="content">
    <div class="tabs">
      <!-- <van-tabs
        v-model:active="activeTab"
        background="transparent"
        title-active-color="#FF89A0"
        color="#FF89A0"
        sticky
      >
        <van-tab title="领取优惠券" :name="0"> -->
      <div class="list">
        <div
          class="item"
          v-for="item in list"
          :key="item.id"
        >
          <CouponItem
            :item="item"
            @click="handleGet(item)"
          />
        </div>

        <div class="bottom">
          <van-loading
            v-show="loading"
            size="18px"
          >加载中...</van-loading>
          <div
            class="none"
            v-show="nomore"
          >没有更多数据了</div>
        </div>
      </div>
      <!-- </van-tab>
      </van-tabs> -->
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
import { useAuth } from "@/hooks/useAuth";
import { center, receive } from "@/api/coupon";
import { useScrollBottom } from "@/hooks/useScroll";
import CouponItem from "@/components/CouponItem";
import { Toast } from "vant"

// const activeTab = ref(0);
const list = ref([]);
const nomore = ref(false);
const loading = ref(false);
const query = reactive({
  page: 1,
  limit: 10,
});

async function init() {
  if (nomore.value) return;
  try {
    loading.value = true;
    const {
      data: { data },
    } = await center(query);
    if (!data.length) {
      nomore.value = true;
    }
    list.value = [...list.value, ...data];
  } finally {
    loading.value = false;
  }
}

async function handleGet({ id }) {
  await receive({ id })
  Toast('领取成功')
}

//滚动事件
useScrollBottom(() => {
  if (nomore.value) return;
  query.page++;
  init();
}, 100);
// 授权钩子
useAuth(
  {
    auth_type: 2,
  },
  () => init()
);
</script>
<style lang="less" scoped>
.content {
  min-height: 100vh;
  background-color: #fafafa;

  .tabs {
    ::v-deep .van-tab__text {
      font-size: 18px;
    }

    .list {
      padding: 20px;

      .bottom {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: @padding-sm 0;

        .none {
          color: #969799;
          font-size: @font-size-base;
        }
      }

      .item {
        margin-top: 12px;

        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
}
</style>